import React from 'react';
import { EyeOutlined, ThunderboltOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { Components } from '@fasstech/flexiget';
import { useDocumentContext } from '../../../../context/Document';

const EyeIcon = () => <EyeOutlined/>;
const SaveIcon = () => <ThunderboltOutlined/>;
const Tp = ({
  title,
  children
}) => <Components.Tooltip placement="left" title={title}>{children}</Components.Tooltip>;

const DocumentActions = ({ userCanEdit }) => {
  const {
    isEdit,
    previewDocumentHtml,
    previewHtmlLoading,
    handleSaveBtn,
    loading,
    nameIsDefined
  } = useDocumentContext();

  const titleSave = isEdit ? 'Sauvegarder le document' : 'Créer le document';
  return (
    <div className="preview-actions-container">
      <div className="preview-actions-content">
        <div className="preview-actions-btn">
          <Tp title="Prévisualiser">
            <Button
              onClick={previewDocumentHtml}
              loading={previewHtmlLoading}
              icon={<EyeIcon/>}
            >
              Prévisualiser
            </Button>
          </Tp>
        </div>
        {userCanEdit && (
          <div className="preview-actions-btn">
            <Tp title={titleSave}>
              <Button
                type="primary"
                onClick={() => handleSaveBtn(false)}
                disabled={!nameIsDefined}
                loading={loading}
                icon={<SaveIcon/>}
              >
                {titleSave}
              </Button>
            </Tp>
          </div>
        )}
      </div>
    </div>
  );
};

export default DocumentActions;
